import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Types } from '@blumtechgroup/blum-ui-utils';

const _selectLocationInitQuery = (locationId: string) => ({
  locations_by_pk: params(
    { id: rawString(locationId) },
    {
      name: types.string,
      organisation: {
        name: types.string,
      },
      users_location_admins_aggregate: {
        aggregate: {
          count: types.number,
        },
      },
      users_clinicians_aggregate: {
        aggregate: {
          count: types.number,
        },
      },
      tbsa_results_aggregate: {
        aggregate: {
          count: types.number,
        },
      },
    }
  ),
});

type X = Types.Unpacked<typeof _selectLocationInitQuery>;
export type Location = X['locations_by_pk'];

export const selectLocationInitQuery = (locationId: string) =>
  gql`
    ${query(_selectLocationInitQuery(locationId))}
  `;
